// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","350":"component---src-pages-impressum-js","496":"component---src-pages-datenschutz-js"}[chunkId] + "-" + {"125":"e456d9aa05ffb13c354c","293":"fbd43ded3b5f22702e1c","350":"3dc99695f94e3c71f3ca","496":"48cf82e62eba4c645fb9"}[chunkId] + ".js";
};